"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sizeOverrides = void 0;
var buttons_1 = require("../../../shared/buttons");
exports.sizeOverrides = [
    {
        props: { size: 'XS' },
        style: {
            borderRadius: '1.25rem',
            padding: buttons_1.XSMALL_BUTTON_PADDING,
            minHeight: buttons_1.XSMALL_BUTTON_HEIGHT,
        },
    },
    {
        props: { size: 'S' },
        style: {
            borderRadius: '1.625rem',
            padding: buttons_1.SMALL_BUTTON_PADDING,
            minHeight: buttons_1.SMALL_BUTTON_HEIGHT,
        },
    },
    {
        props: { size: 'M' },
        style: {
            borderRadius: '1.625rem',
            padding: buttons_1.MEDIUM_BUTTON_PADDING,
            minHeight: buttons_1.MEDIUM_BUTTON_HEIGHT,
        },
    },
    {
        props: { size: 'L' },
        style: {
            borderRadius: '2rem',
            padding: buttons_1.LARGE_BUTTON_PADDING,
            minHeight: buttons_1.LARGE_BUTTON_HEIGHT,
        },
    },
    {
        props: { size: 'XS', variant: 'tertiaryDefault' },
        style: {
            borderRadius: '1.25rem',
            padding: buttons_1.TERTIARY_XSMALL_BUTTON_PADDING,
            minHeight: buttons_1.XSMALL_BUTTON_HEIGHT,
        },
    },
    {
        props: { size: 'XS', variant: 'tertiaryHC' },
        style: {
            borderRadius: '1.25rem',
            padding: buttons_1.TERTIARY_XSMALL_BUTTON_PADDING,
            minHeight: buttons_1.XSMALL_BUTTON_HEIGHT,
        },
    },
    {
        props: { size: 'S', variant: 'tertiaryDefault' },
        style: {
            borderRadius: '1.625rem',
            padding: buttons_1.TERTIARY_SMALL_BUTTON_PADDING,
            minHeight: buttons_1.SMALL_BUTTON_HEIGHT,
        },
    },
    {
        props: { size: 'S', variant: 'tertiaryHC' },
        style: {
            borderRadius: '1.625rem',
            padding: buttons_1.TERTIARY_SMALL_BUTTON_PADDING,
            minHeight: buttons_1.SMALL_BUTTON_HEIGHT,
        },
    },
    {
        props: { size: 'M', variant: 'tertiaryDefault' },
        style: {
            borderRadius: '1.625rem',
            padding: buttons_1.TERTIARY_MEDIUM_BUTTON_PADDING,
            minHeight: buttons_1.MEDIUM_BUTTON_HEIGHT,
        },
    },
    {
        props: { size: 'M', variant: 'tertiaryHC' },
        style: {
            borderRadius: '1.625rem',
            padding: buttons_1.TERTIARY_MEDIUM_BUTTON_PADDING,
            minHeight: buttons_1.MEDIUM_BUTTON_HEIGHT,
        },
    },
    {
        props: { size: 'L', variant: 'tertiaryDefault' },
        style: {
            borderRadius: '2rem',
            padding: buttons_1.TERTIARY_LARGE_BUTTON_PADDING,
            minHeight: buttons_1.LARGE_BUTTON_HEIGHT,
        },
    },
    {
        props: { size: 'L', variant: 'tertiaryHC' },
        style: {
            borderRadius: '2rem',
            padding: buttons_1.TERTIARY_LARGE_BUTTON_PADDING,
            minHeight: buttons_1.LARGE_BUTTON_HEIGHT,
        },
    },
];
